import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/management/users')({
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: 'Alle',
  }),
});
